import React, { useEffect, useState } from "react";
// Chakra imports
import {
  Box,
  Button,
  Flex,
  Grid,
  Icon,
  Spacer,
  Text,
  FormControl,
  FormLabel,
  HStack,
  Input,
  Link,
  Switch,
  DarkMode,
  Select,
  color,
  IconButton,
  Checkbox,
  background,
  Badge,
  Textarea,
  Image,
  useToast,
} from "@chakra-ui/react";

// Images

// Custom components
import Card from "components/Card/Card.js";
import CardBody from "components/Card/CardBody.js";
import CardHeader from "components/Card/CardHeader.js";
import GradientBorder from "components/GradientBorder/GradientBorder";
import BillingRow from "components/Tables/BillingRow";

// Data
import { AddIcon } from "@chakra-ui/icons";
import useApiReq from "variables/apireq";
import { useLoader } from "components/Loader/loader";
import { AiFillCloseCircle, AiFillCloseSquare } from "react-icons/ai";
import { useHistory } from "react-router-dom/cjs/react-router-dom";
import GroupModal from "./PRGroupAdd";
import { motion } from "framer-motion";
import ChakraStyledSelect from "components/CustomField/ChakraStyledSelect";
import { BsFillEyeFill } from "react-icons/bs";
import { from } from "stylis";

const locationList = [
  { label: "Bangladesh", value: "Bangladesh" },
  { label: "Dhaka", value: "Dhaka" },
  { label: "Chattogram", value: "Chattogram" },
  { label: "Khulna", value: "Khulna" },
  { label: "Rajshahi", value: "Rajshahi" },
  { label: "Sylhet", value: "Sylhet" },
  { label: "Barishal", value: "Barishal" },
  { label: "Rangpur", value: "Rangpur" },
  { label: "Mymensingh", value: "Mymensingh" },
];

// const locationList = [
//   { label: "Bagerhat", value: "Bagerhat" },
//   { label: "Bandarban", value: "Bandarban" },
//   { label: "Barguna", value: "Barguna" },
//   { label: "Barishal", value: "Barishal" },
//   { label: "Bhola", value: "Bhola" },
//   { label: "Bogura", value: "Bogura" },
//   { label: "Brahmanbaria", value: "Brahmanbaria" },
//   { label: "Chandpur", value: "Chandpur" },
//   { label: "Chattogram", value: "Chattogram" },
//   { label: "Chuadanga", value: "Chuadanga" },
//   { label: "Cox's Bazar", value: "Cox's Bazar" },
//   { label: "Cumilla", value: "Cumilla" },
//   { label: "Dhaka", value: "Dhaka" },
//   { label: "Dinajpur", value: "Dinajpur" },
//   { label: "Faridpur", value: "Faridpur" },
//   { label: "Feni", value: "Feni" },
//   { label: "Gaibandha", value: "Gaibandha" },
//   { label: "Gazipur", value: "Gazipur" },
//   { label: "Gopalganj", value: "Gopalganj" },
//   { label: "Habiganj", value: "Habiganj" },
//   { label: "Jamalpur", value: "Jamalpur" },
//   { label: "Jashore", value: "Jashore" },
//   { label: "Jhalokathi", value: "Jhalokathi" },
//   { label: "Jhenaidah", value: "Jhenaidah" },
//   { label: "Joypurhat", value: "Joypurhat" },
//   { label: "Khagrachari", value: "Khagrachari" },
//   { label: "Khulna", value: "Khulna" },
//   { label: "Kishoreganj", value: "Kishoreganj" },
//   { label: "Kurigram", value: "Kurigram" },
//   { label: "Kushtia", value: "Kushtia" },
//   { label: "Lakshmipur", value: "Lakshmipur" },
//   { label: "Lalmonirhat", value: "Lalmonirhat" },
//   { label: "Madaripur", value: "Madaripur" },
//   { label: "Magura", value: "Magura" },
//   { label: "Manikganj", value: "Manikganj" },
//   { label: "Meherpur", value: "Meherpur" },
//   { label: "Moulvibazar", value: "Moulvibazar" },
//   { label: "Munshiganj", value: "Munshiganj" },
//   { label: "Mymensingh", value: "Mymensingh" },
//   { label: "Naogaon", value: "Naogaon" },
//   { label: "Narail", value: "Narail" },
//   { label: "Narayanganj", value: "Narayanganj" },
//   { label: "Narsingdi", value: "Narsingdi" },
//   { label: "Natore", value: "Natore" },
//   { label: "Netrokona", value: "Netrokona" },
//   { label: "Nilphamari", value: "Nilphamari" },
//   { label: "Noakhali", value: "Noakhali" },
//   { label: "Pabna", value: "Pabna" },
//   { label: "Panchagarh", value: "Panchagarh" },
//   { label: "Patuakhali", value: "Patuakhali" },
//   { label: "Pirojpur", value: "Pirojpur" },
//   { label: "Rajbari", value: "Rajbari" },
//   { label: "Rajshahi", value: "Rajshahi" },
//   { label: "Rangamati", value: "Rangamati" },
//   { label: "Rangpur", value: "Rangpur" },
//   { label: "Satkhira", value: "Satkhira" },
//   { label: "Shariatpur", value: "Shariatpur" },
//   { label: "Sherpur", value: "Sherpur" },
//   { label: "Sirajganj", value: "Sirajganj" },
//   { label: "Sunamganj", value: "Sunamganj" },
//   { label: "Sylhet", value: "Sylhet" },
//   { label: "Tangail", value: "Tangail" },
//   { label: "Thakurgaon", value: "Thakurgaon" },
// ];

const targetingList = [
  { label: "Age", value: "Age" },
  { label: "Rich", value: "Rich" },
  { label: "Poor", value: "Poor" },
  { label: "Middle Class", value: "Middle Class" },
];
const ageGroupList = [
  { label: "All", value: "all" },
  { label: "18-24", value: "18-24" },
  { label: "25-34", value: "25-34" },
  { label: "35-44", value: "35-44" },
  { label: "45-54", value: "45-54" },
  { label: "55-64", value: "55-64" },
  { label: "65+", value: "65+" },
  // { label: "All", value: "All" },
];

const interestsList = [
  { label: "All", value: "All" },
  { label: "Advertising & Marketing", value: "Advertising & Marketing" },
  { label: "Agriculture", value: "Agriculture" },
  { label: "Architecture", value: "Architecture" },
  { label: "Aviation", value: "Aviation" },
  { label: "Banking", value: "Banking" },
  { label: "Business", value: "Business" },
  { label: "Construction", value: "Construction" },
  { label: "Real Estate", value: "Real Estate" },
  { label: "Design", value: "Design" },
  { label: "Economics", value: "Economics" },
  { label: "Engineering", value: "Engineering" },
  { label: "Entrepreneurship", value: "Entrepreneurship" },
  { label: "Health Care", value: "Health Care" },
  { label: "Higher Education", value: "Higher Education" },
  { label: "Management", value: "Management" },
  { label: "Nursing", value: "Nursing" },
  { label: "Online Marketing", value: "Online Marketing" },
  { label: "Personal Finance", value: "Personal Finance" },
  { label: "Retail", value: "Retail" },
  { label: "Sales", value: "Sales" },
  { label: "Science", value: "Science" },
  { label: "Small business", value: "Small business" },
  { label: "Entertainment", value: "Entertainment" },
  { label: "Games", value: "Games" },
  { label: "Live Events", value: "Live Events" },
  { label: "Movies", value: "Movies" },
  { label: "Music", value: "Music" },
  { label: "Reading", value: "Reading" },
  { label: "TV", value: "TV" },
  { label: "Fitness and wellness", value: "Fitness and wellness" },
  { label: "Yoga", value: "Yoga" },
  { label: "Food and drink", value: "Food and drink" },
  { label: "Hobbies and activities", value: "Hobbies and activities" },
  { label: "Travel", value: "Travel" },
  { label: "Vehicles", value: "Vehicles" },
  { label: "Shopping and fashion", value: "Shopping and fashion" },
  { label: "Sports and outdoors", value: "Sports and outdoors" },
  { label: "Technology", value: "Technology" },
];

function UpdateCampaign() {
  const titleColor = "white";
  const textColor = "gray.400";
  const [data, setData] = useState([]);
  const [hidden, setHidden] = useState(false);
  const [error, setError] = useState(null);
  const [isOpen, setOpen] = useState(false);
  const [selected, setSelected] = useState(null);
  const { setIsLoading, isLoading } = useLoader();
  const [groups, setGroups] = useState([]);
  const [selectedTargeting, setSelectedTargeting] = useState([]);
  const [selectedInterests, setSelectedInterests] = useState([]);
  const [selectedLocation, setSelectedLocation] = useState([]);
  const [selectedAgeGroup, setSelectedAgeGroup] = useState([]);
  const [getOrderByType, setGetOrderByType] = useState([]);
  const [isgroupUpdated, setGroupUpdated] = useState(false);
  const [selectedbanner, setSelectedBanner] = useState([]);
  const [selectedContent, setSelectedContent] = useState(null);
  const history = useHistory();
  const [isInvalid, setIsInvalid] = useState(false);
  const [campaignList, setCampaignList] = useState([]);
  const [selectedCampaign, setSelectedCampaign] = useState();
  const [isSelectedContent, setIsSelectedContent] = useState(false);
  const [isTypeShown, setIsTypeShown] = useState(false);
  const [isShowAnalytics, setIsShowAnalytics] = useState(false);
  const toast = useToast({ position: "top" });

  const [formData, setFormData] = useState({
    prTopic: "",
    socialMedia: false,
    analytics: false,
    prgroup: "",
    ageGroup: "",
    gender: "",
    locationList: "",
    targetingList: "",
    content: "",
    banner: "",
    prType: "",
    package: "",
  });
  const setIsOpen = () => {
    setOpen(!isOpen);
  };
  const hide = () => {
    setHidden(!hidden);
  };
  useEffect(() => {
    if (selectedLocation) {
      const first10 = selectedLocation.map((item) => item.value).splice(0, 5);
      const rest =
        selectedLocation.length > 5
          ? ` +${selectedLocation.length - 5} more`
          : "";
      setFormData((prev) => ({
        ...prev,
        locationList: first10.join(", ") + rest,
      }));
    }
  }, [selectedLocation]);

  useEffect(() => {
    if (selectedTargeting) {
      const first10 = selectedTargeting.map((item) => item.value).splice(0, 5);
      const rest =
        selectedTargeting.length > 5
          ? ` +${selectedTargeting.length - 5} more`
          : "";
      setFormData((prev) => ({
        ...prev,
        targetingList: first10.join(", ") + rest,
      }));
    }
  }, [selectedTargeting]);

  useEffect(() => {
    if (selectedInterests) {
      const first10 = selectedInterests.map((item) => item.value).splice(0, 5);
      const rest =
        selectedInterests.length > 5
          ? ` +${selectedInterests.length - 5} more`
          : "";
      setFormData((prev) => ({
        ...prev,
        interestsList: first10.join(", ") + rest,
      }));
    }
  }, [selectedInterests]);

  useEffect(() => {
    if (selectedAgeGroup) {
      const first10 = selectedAgeGroup.map((item) => item.value).splice(0, 5);
      const rest =
        selectedAgeGroup.length > 5
          ? ` +${selectedAgeGroup.length - 5} more`
          : "";
      setFormData((prev) => ({
        ...prev,
        selectedAgeGroup: first10.join(", ") + rest,
      }));
    }
  }, [selectedAgeGroup]);

  const handleChange = (e) => {
    const { name, value, type, checked, files } = e.target;

    if (name === "advertiser" && value !== "") {
      setIsTypeShown(true);
    }

    if (name === "prType" && value === "Online&Analytic") {
      setIsShowAnalytics(true);
    }

    if (name === "prType" && value !== "Online&Analytic") {
      setIsShowAnalytics(false);
    }

    if (name === "prType" && value !== "") {
      console.log(selectedCampaign.value);
      fetchOrder(
        value,
        data.find((item) => item.uuid === selectedCampaign.value).advertiser
      );
    }

    if (name === "content") {
      // convert to base64
      const file = e.target.files[0];
      if (file) {
        setIsInvalid(false);

        if (file.size > 1 * 1024 * 1024) {
          e.target.value = null;
          toast({
            title: "ALART",
            description: "File Size Is Too Large",
            status: "error",
            duration: 5000,
            isClosable: true,
          });
          setIsInvalid(true);
          return;
        }

        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onloadend = () => {
          setSelectedContent(reader.result);
        };
      }
    }

    if (name === "banner") {
      const newFiles = Array.from(files);

      if (newFiles.length > 5) {
        toast({
          title: "ALERT",
          description: "You can only upload up to 5 files",
          status: "error",
          duration: 5000,
          isClosable: true,
        });
        return;
      }

      const fileReaders = [];
      const previews = [];

      newFiles.forEach((file) => {
        if (file.size > 1 * 1024 * 1024) {
          toast({
            title: "ALERT",
            description: `File "${file.name}" is too large`,
            status: "error",
            duration: 5000,
            isClosable: true,
          });
          return;
        }

        const reader = new FileReader();
        fileReaders.push(
          new Promise((resolve) => {
            reader.onloadend = () => resolve({ file, preview: reader.result });
          })
        );
        reader.readAsDataURL(file);
      });

      Promise.all(fileReaders).then((results) => {
        setSelectedBanner((prev) => [
          ...prev,
          ...results.map((res) => res.preview),
        ]);

        setFormData((prev) => ({
          ...prev,
          banner: [...(prev.banner || []), ...results.map((res) => res.file)],
        }));
      });

      return;
    }

    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const removeBannerItem = (indexToRemove) => {
    setSelectedBanner((prev) => prev.filter((_, i) => i !== indexToRemove));
    setFormData((prev) => ({
      ...prev,
      banner: prev.banner?.filter((_, i) => i !== indexToRemove),
    }));
  };

  const handleEmptyFields = () => {
    setFormData((prev) =>
      Object.fromEntries(
        Object.entries(prev).filter(([_, value]) => value && value.length > 0)
      )
    );
  };

  const handleContentClick = (value) => {
    const mimeMatch = value.match(/^data:(.*?);base64,/);
    if (!mimeMatch) return;

    const mimeType = mimeMatch[1];

    // Expanded MIME to extension mapping
    const mimeToExt = {
      "application/pdf": "pdf",
      "application/msword": "doc",
      "application/vnd.openxmlformats-officedocument.wordprocessingml.document":
        "docx",
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet":
        "xlsx",
      "text/plain": "txt",
      "application/vnd.ms-excel": "xls",
      "application/vnd.ms-powerpoint": "ppt",
      "application/vnd.openxmlformats-officedocument.presentationml.presentation":
        "pptx",
    };

    const fileExt = mimeToExt[mimeType] || "file"; // default fallback
    const base64Data = value.split(",")[1];

    const byteCharacters = atob(base64Data);
    const byteNumbers = new Array(byteCharacters.length)
      .fill()
      .map((_, i) => byteCharacters.charCodeAt(i));
    const byteArray = new Uint8Array(byteNumbers);

    const blob = new Blob([byteArray], {
      type: mimeType,
    });
    const fileURL = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = fileURL;
    a.download = `content.${fileExt}`;
    a.click();
  };

  const fetchCampaignGroup = async () => {
    try {
      const res = await useApiReq({
        method: "GET",
        url: "group/",
        headers: {
          accept: "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      });
      if (res.error) {
        setError(res.error?.message || res.error);
      } else {
        setGroups(res.response);
        if (selectedCampaign) {
          const campaign = data.find(
            (item) => item.uuid === selectedCampaign.value
          );
          handleChange({
            target: { name: "prgroup", value: campaign.group?.uuid },
          });
        }
      }
    } catch (err) {
      setError(err);
    }
  };

  const groupUpdated = () => {
    setGroupUpdated(!isgroupUpdated);
  };

  const fetchOrder = async (prType = null, advertiser_uuid) => {
    try {
      var data2 = {
        advertiser_uuid: advertiser_uuid,
      };
      if (prType) {
        data2.type = prType;
      }
      const params = new URLSearchParams(data2);
      const res = await useApiReq({
        method: "GET",
        url: `order/` + `?${params.toString()}`,
        headers: {
          accept: "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      });
      if (res.error) {
        setError(res.error?.message || res.error);
      } else {
        setGetOrderByType(res.response);
      }
    } catch (err) {
      setError(err);
    } finally {
      setIsLoading(false);
      const campaign = data.find(
        (item) => item.uuid === selectedCampaign.value
      );

      setFormData((prev) => ({
        ...prev,
        package: campaign.package.uuid,
      }));
    }
  };

  const fetchCampaigns = async () => {
    try {
      const res = await useApiReq({
        method: "POST",
        url: "campaign/",
        headers: {
          accept: "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      });
      if (res.error) {
        setError(res.error?.message || res.error);
      } else {
        setData(res.response);
        setCampaignList(
          res.response.map((item) => ({
            label: item.name,
            value: item.uuid,
          }))
        );
        if (localStorage.getItem("group") === "Advertiser") {
          handleChange({
            target: {
              name: res.response[0].user.username,
              value: res.response[0].uuid,
            },
          });
        }
      }
    } catch (err) {
      setError(err);
    } finally {
      await fetchCampaignGroup();
      if (isgroupUpdated) {
        groupUpdated();
      }

      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchCampaigns();
  }, []);

  useEffect(() => {
    if (selectedCampaign) {
      console.log(selectedCampaign);
      setIsSelectedContent(true);
      setIsTypeShown(true);
      const campaign = data.find(
        (item) => item.uuid === selectedCampaign.value
      );

      setFormData({
        prTopic: campaign.name,
        socialMedia: campaign.package.facebook,
        analytics: campaign.package.analytics,
        brandName: campaign.brand_name,
        objective: campaign.objective,
        // content: campaign.content,
        gender: campaign.gender,
        // prgroup: campaign.group?.uuid,
        prType: campaign.type,
        additionalInfo: campaign.additional_info,
      });

      setSelectedBanner(JSON.parse(campaign.banner));
      setSelectedContent(campaign.content);
      // setSelectedBanner(campaign.banner.map((item) => item.url));
      setSelectedAgeGroup(
        campaign.age_groups.map((item) => ({
          label: item,
          value: item,
        }))
      );
      setSelectedLocation(
        campaign.location_list.map((item) => ({
          label: item,
          value: item,
        }))
      );
      // setSelectedTargeting(
      //   campaign.targeting_list.map((item) => ({
      //     label: item,
      //     value: item,
      //   }))
      // );
      setSelectedInterests(
        campaign.targeting_list.map((item) => ({
          label: item,
          value: item,
        }))
      );

      if (campaign.package.type === "Online&Analytic") {
        setIsShowAnalytics(true);
      } else {
        setIsShowAnalytics(false);
      }

      fetchOrder(campaign.package.type, campaign.advertiser);
    }
  }, [selectedCampaign]);

  const fetchUpdateCampaing = async (data) => {
    setIsLoading(true);
    setError(null);
    try {
      const res = await useApiReq({
        method: "PATCH",
        url: `campaign/edit/${selectedCampaign.value}/`,
        data: data,
        headers: {
          accept: "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      });
      if (res.error) {
        setError(res.error?.message || res.error);
      } else {
        toast({
          title: "Success",
          description: "Campaign Updated Successfully",
          status: "success",
          duration: 5000,
          isClosable: true,
        });
        setFormData({
          prTopic: "",
          type: "",
          socialMedia: false,
          analytics: false,
          additionalInfo: "",
          prgroup: "",
          brandName: "",
          objective: "",
          content: "",
          banner: "",
          advertiser: "",
        });
        setSelectedBanner([]);
        if (hidden) {
          hide();
        }

        history.push(`/${localStorage.getItem("group").toLowerCase()}/pr/list`);
      }
    } catch (err) {
      setError(err);
    } finally {
      setIsLoading(false);
    }
  };
  useEffect(() => {
    if (error) {
      toast({
        title: "Error",
        description: error,
        status: "error",
        duration: 5000,
        isClosable: true,
      });
    }
  }, [error]);
  const handleSubmit = (e) => {
    e.preventDefault();

    if (
      formData.prTopic === "" ||
      formData.brandName === "" ||
      formData.objective === "" ||
      formData.prType === "" ||
      formData.package === "" ||
      selectedbanner.length === 0 ||
      selectedContent === ""
    ) {
      toast({
        title: "Error",
        description: "Please fill all the fields",
        status: "error",
        duration: 5000,
        isClosable: true,
      });
      return;
    }

    const data = {
      name: formData.prTopic,
      brand_name: formData.brandName,
      objective: formData.objective,
      content: selectedContent,
      type: formData.prType,
      group: formData.prgroup,
      objective: formData.objective,
      banner: JSON.stringify(selectedbanner),
      advertiser_uuid: formData.advertiser,
      additional_info: formData.additionalInfo,
      package: formData.package,

      age_groups:
        selectedAgeGroup.length > 0
          ? selectedAgeGroup.map((item) => item.value)
          : [],
      gender: formData.gender,
      location_list:
        selectedLocation.length > 0
          ? selectedLocation.map((item) => item.value)
          : [],
      // targeting_list:
      //   selectedTargeting.length > 0
      //     ? selectedTargeting.map((item) => item.value)
      //     : [],
      targeting_list:
        selectedInterests.length > 0
          ? selectedInterests.map((item) => item.value)
          : [],
    };
    if (formData.prgroup) {
      data.group_uuid = formData.prgroup;
    } else {
      data.group = null;
    }
    fetchUpdateCampaing(data);
  };
  if (isLoading) {
    return <div></div>;
  }
  return (
    <Flex direction="column" pt={{ base: "120px", md: "75px" }} mx="auto">
      <Grid templateColumns={{ sm: "1fr", lg: "60% 38%" }}>
        {/* Form */}
        <Card p="16px">
          <CardHeader>
            <Flex
              justify="space-between"
              align="center"
              minHeight="60px"
              w="100%"
            >
              <Text fontSize="lg" color="#fff" fontWeight="bold">
                PR Update
              </Text>
            </Flex>
          </CardHeader>
          <CardBody>
            <Flex
              justify="space-between"
              align="center"
              minHeight="60px"
              w="100%"
            >
              <GradientBorder
                p="2px"
                ml={{ base: "0px", lg: "24px" }}
                w="100%"
                me={{ base: "none", lg: "30px", xl: "none" }}
                background="transparent"
                boxShadow="0px 0px 2px 2px rgba(255,255,255,0.1)"
                borderRadius="30px"
              >
                <Flex
                  background="transparent"
                  borderRadius="30px"
                  direction="column"
                  p="40px"
                  minW={{ base: "unset", md: "430px", xl: "450px" }}
                  w="100%"
                  mx={{ base: "0px" }}
                  bg={{
                    base: "rgba(19,21,56,.5)",
                  }}
                >
                  <form onSubmit={handleSubmit}>
                    <FormControl>
                      <FormLabel
                        color={titleColor}
                        ms="4px"
                        fontSize="sm"
                        fontWeight="normal"
                      >
                        Select Campaign
                      </FormLabel>
                      <GradientBorder
                        mb="24px"
                        minH="50px"
                        w={{ base: "100%", lg: "100%" }}
                        borderRadius="20px"
                      >
                        <ChakraStyledSelect
                          placeholder="Select Campaign"
                          options={campaignList}
                          selectedValue={selectedCampaign}
                          setSelectedValue={setSelectedCampaign}
                          isMulti={false}
                        />
                      </GradientBorder>
                      <FormLabel
                        color={titleColor}
                        ms="4px"
                        fontSize="sm"
                        fontWeight="normal"
                      >
                        PR Topic
                      </FormLabel>
                      <GradientBorder
                        mb="24px"
                        h="50px"
                        w={{ base: "100%", lg: "100%" }}
                        borderRadius="20px"
                      >
                        <Input
                          color={titleColor}
                          bg={{
                            base: "rgb(19,21,54)",
                          }}
                          border="transparent"
                          borderRadius="20px"
                          fontSize="sm"
                          size="lg"
                          w={{ base: "100%", lg: "100%" }}
                          maxW="100%"
                          h="46px"
                          type="text"
                          placeholder="PR Topic"
                          name="prTopic"
                          value={formData.prTopic}
                          onChange={handleChange}
                          required
                        />
                      </GradientBorder>

                      {!hidden && (
                        <Flex gap={4} justify="space-between" align="center">
                          <div style={{ width: "100%" }}>
                            <FormLabel
                              color={titleColor}
                              ms="4px"
                              fontSize="sm"
                              fontWeight="normal"
                            >
                              Pr Group
                            </FormLabel>

                            <GradientBorder
                              mb="24px"
                              h="50px"
                              w={{ base: "100%", lg: "100%" }}
                              borderRadius="20px"
                            >
                              <Select
                                color={titleColor}
                                bg={{
                                  base: "rgb(19,21,54)",
                                }}
                                border="transparent"
                                borderRadius="20px"
                                fontSize="sm"
                                size="lg"
                                w={{ base: "100%", lg: "100%" }}
                                maxW="100%"
                                h="46px"
                                required={false}
                                type="text"
                                placeholder="Select Group"
                                name="prgroup"
                                value={formData.prgroup || ""}
                                onChange={handleChange}
                                sx={{
                                  option: {
                                    backgroundColor: "rgb(19,21,54)",
                                    color: "white",
                                  },
                                }}
                              >
                                {groups?.map((item) => (
                                  <option key={item.uuid} value={item.uuid}>
                                    {item.group_name}
                                  </option>
                                ))}
                              </Select>
                            </GradientBorder>
                          </div>
                          <IconButton
                            aria-label="Add"
                            icon={<Icon as={AddIcon} />}
                            size="md"
                            mt="5px"
                            color={"white"}
                            colorScheme="brand"
                            onClick={setIsOpen}
                            variant="solid"
                          />
                          <IconButton
                            aria-label="Add"
                            icon={<Icon as={AiFillCloseCircle} />}
                            size="md"
                            mt="5px"
                            color={"white"}
                            colorScheme="brand"
                            onClick={hide}
                            variant="solid"
                          />
                        </Flex>
                      )}

                      <FormLabel
                        color={titleColor}
                        ms="4px"
                        fontSize="sm"
                        fontWeight="normal"
                      >
                        Brand Name
                      </FormLabel>

                      <GradientBorder
                        mb="24px"
                        h="50px"
                        w={{ base: "100%", lg: "100%" }}
                        borderRadius="20px"
                      >
                        <Input
                          color={titleColor}
                          bg={{
                            base: "rgb(19,21,54)",
                          }}
                          border="transparent"
                          borderRadius="20px"
                          fontSize="sm"
                          size="lg"
                          w={{ base: "100%", lg: "100%" }}
                          maxW="100%"
                          type="text"
                          placeholder="Brand Name"
                          name="brandName"
                          value={formData.brandName}
                          onChange={handleChange}
                          required
                        />
                      </GradientBorder>

                      <FormLabel
                        color={titleColor}
                        ms="4px"
                        fontSize="sm"
                        fontWeight="normal"
                      >
                        PR Type
                      </FormLabel>

                      <GradientBorder
                        mb="14px"
                        w={{ base: "100%", lg: "100%" }}
                        borderRadius="20px"
                      >
                        <Select
                          color={titleColor}
                          bg={{
                            base: "rgb(19,21,54)",
                          }}
                          _disabled={{
                            background: "rgb(19,21,54) !important",
                            base: "rgb(19,21,54) !important",
                            cursor: "not-allowed",
                          }}
                          border="transparent"
                          borderRadius="20px"
                          fontSize="sm"
                          size="lg"
                          w={{ base: "100%", lg: "100%" }}
                          maxW="100%"
                          h="46px"
                          required={true}
                          type="text"
                          placeholder="Select PR Type"
                          name="prType"
                          value={formData.prType}
                          onChange={handleChange}
                          sx={{
                            option: {
                              backgroundColor: "rgb(19,21,54)",
                              color: "white",
                            },
                          }}
                          disabled={!isTypeShown}
                        >
                          <option value="Online">Online</option>
                          <option value="Print">Print</option>
                          <option value="Online&Analytic">
                            Online&Analytic
                          </option>
                        </Select>
                      </GradientBorder>

                      <FormLabel
                        color={titleColor}
                        ms="4px"
                        fontSize="sm"
                        fontWeight="normal"
                      >
                        Select Package
                      </FormLabel>
                      <GradientBorder
                        mb="24px"
                        h="50px"
                        w={{ base: "100%", lg: "100%" }}
                        borderRadius="20px"
                      >
                        <Select
                          color={titleColor}
                          bg={{
                            base: "rgb(19,21,54)",
                          }}
                          _disabled={{
                            background: "rgb(19,21,54) !important",
                            base: "rgb(19,21,54) !important",
                            cursor: "not-allowed",
                          }}
                          border="transparent"
                          borderRadius="20px"
                          disabled={getOrderByType.length === 0}
                          fontSize="sm"
                          size="lg"
                          w={{ base: "100%", lg: "100%" }}
                          maxW="100%"
                          h="46px"
                          type="text"
                          name="package"
                          placeholder="Select Package"
                          value={formData.package}
                          onChange={handleChange}
                          required
                          sx={{
                            option: {
                              backgroundColor: "rgb(19,21,54)",
                              color: "white",
                            },
                          }}
                        >
                          {getOrderByType?.map((item) => (
                            <option key={item.uuid} value={item.uuid}>
                              {item.package_name}
                            </option>
                          ))}
                        </Select>
                      </GradientBorder>

                      <FormLabel
                        color={titleColor}
                        ms="4px"
                        fontSize="sm"
                        fontWeight="normal"
                      >
                        Objective
                      </FormLabel>

                      <GradientBorder
                        mb="14px"
                        w={{ base: "100%", lg: "100%" }}
                        borderRadius="20px"
                      >
                        <Textarea
                          color={titleColor}
                          bg={{
                            base: "rgb(19,21,54)",
                          }}
                          rows={3}
                          overflowY={"auto"}
                          maxH="4.5em"
                          resize={"none"}
                          border="transparent"
                          borderRadius="20px"
                          fontSize="sm"
                          size="lg"
                          w={{ base: "100%", lg: "100%" }}
                          maxW="100%"
                          type=""
                          placeholder="Objective"
                          name="objective"
                          value={formData.objective}
                          onChange={handleChange}
                          required
                        />
                      </GradientBorder>
                      {/* <FormLabel
                        color={titleColor}
                        ms="4px"
                        fontSize="sm"
                        fontWeight="normal"
                      >
                        Content
                      </FormLabel>

                      <GradientBorder
                        mb="14px"
                        w={{ base: "100%", lg: "100%" }}
                        borderRadius="20px"
                      >
                        <Textarea
                          color={titleColor}
                          bg={{
                            base: "rgb(19,21,54)",
                          }}
                          rows={3}
                          overflowY={"auto"}
                          maxH="4.5em"
                          resize={"none"}
                          border="transparent"
                          borderRadius="20px"
                          fontSize="sm"
                          size="lg"
                          w={{ base: "100%", lg: "100%" }}
                          maxW="100%"
                          type=""
                          placeholder="Content"
                          name="content"
                          value={formData.content}
                          onChange={handleChange}
                        />
                      </GradientBorder> */}
                      <Flex
                        direction="row"
                        justifyContent={"space-between"}
                        align="center"
                        w={"100%"}
                        mb="16px"
                      >
                        <FormLabel
                          color={titleColor}
                          ms="4px"
                          fontSize="sm"
                          fontWeight="normal"
                        >
                          Content
                        </FormLabel>

                        <Input
                          color={titleColor}
                          bg={{
                            base: "transparent",
                          }}
                          maxBlockSize={"200px"}
                          border="transparent"
                          borderRadius="20px"
                          fontSize="sm"
                          size="lg"
                          w="auto"
                          type="file"
                          pt={1}
                          sx={{
                            "::file-selector-button": {
                              background: "rgb(30,33,80)",
                              color: "white",
                              padding: "10px 20px",
                              borderRadius: "10px",
                              border: "none",
                              cursor: "pointer",
                              fontSize: "14px",
                            },
                            "::file-selector-button:hover": {
                              background: "rgb(40,45,100)",
                              cursor: "pointer",
                            },
                          }}
                          accept=".pdf,.ppt,.pptx,.xls,.xlsx,.doc,.docx,.txt"
                          placeholder="Content"
                          name="content"
                          id="contentInput"
                          isInvalid={isInvalid}
                          value={formData.content}
                          onChange={handleChange}
                          style={{ display: "none" }}
                          required
                        />

                        <Flex
                          direction="row"
                          justifyContent={"flex-end"}
                          align="center"
                          w={"100%"}
                          mr="44px"
                          gap={2}
                        >
                          <Button
                            onClick={() =>
                              document.getElementById("contentInput").click()
                            }
                            bg="rgb(30,33,80)"
                            color="white"
                            px="20px"
                            py="10px"
                            borderRadius="10px"
                            fontSize="14px"
                            _hover={{ bg: "rgb(40,45,100)" }}
                          >
                            Upload Content
                          </Button>
                          <Text
                            color={textColor}
                            fontSize="sm"
                            fontWeight="normal"
                            ms="4px"
                          >
                            {selectedContent?.length > 0 ? 1 : "No"} File
                            Selected
                          </Text>
                        </Flex>
                        {isSelectedContent && (
                          <Flex align="center" gap={2}>
                            <Text
                              onClick={() =>
                                handleContentClick(selectedContent)
                              }
                              fontSize="16px"
                              fontWeight="500"
                              style={{ cursor: "pointer" }}
                              color={textColor}
                            >
                              View
                            </Text>
                            <BsFillEyeFill
                              onClick={() =>
                                handleContentClick(selectedContent)
                              }
                              style={{
                                cursor: "pointer",
                                fontSize: "20px",
                                color: "white",
                              }}
                            />
                          </Flex>
                        )}
                      </Flex>
                      <Flex
                        direction="row"
                        justifyContent={"space-between"}
                        align="center"
                        w={"100%"}
                        mb="14px"
                      >
                        <FormLabel
                          color={titleColor}
                          ms="4px"
                          fontSize="sm"
                          fontWeight="normal"
                        >
                          Banner
                        </FormLabel>

                        <Input
                          color={titleColor}
                          bg={{
                            base: "transparent",
                          }}
                          maxBlockSize={"200px"}
                          border="transparent"
                          borderRadius="20px"
                          fontSize="sm"
                          size="lg"
                          w="auto"
                          type="file"
                          multiple
                          pt={1}
                          sx={{
                            "::file-selector-button": {
                              background: "rgb(30,33,80)",
                              color: "white",
                              padding: "10px 20px",
                              borderRadius: "10px",
                              border: "none",
                              cursor: "pointer",
                              fontSize: "14px",
                            },
                            "::file-selector-button:hover": {
                              background: "rgb(40,45,100)",
                              cursor: "pointer",
                            },
                          }}
                          placeholder="Banner"
                          name="banner"
                          id="bannerInput"
                          isInvalid={isInvalid}
                          // value={formData.banner}
                          onChange={handleChange}
                          style={{ display: "none" }}
                          disabled={selectedbanner.length >= 5}
                        />

                        <Flex
                          direction="row"
                          justifyContent={"flex-end"}
                          align="center"
                          w={"100%"}
                          mb="14px"
                          mr="28px"
                          gap={2}
                        >
                          <Button
                            onClick={() =>
                              document.getElementById("bannerInput").click()
                            }
                            bg="rgb(30,33,80)"
                            color="white"
                            px="20px"
                            py="10px"
                            borderRadius="10px"
                            fontSize="14px"
                            _hover={{ bg: "rgb(40,45,100)" }}
                            disabled={selectedbanner.length >= 5}
                          >
                            Upload Banner
                          </Button>

                          <Text
                            color={textColor}
                            fontSize="sm"
                            fontWeight="normal"
                            ms="4px"
                          >
                            {selectedbanner.length > 0
                              ? selectedbanner.length
                              : "No"}{" "}
                            Banner Selected
                          </Text>
                        </Flex>
                      </Flex>
                      <Flex wrap="wrap" justifyContent="flex-end" gap={4}>
                        {selectedbanner.map((src, index) => (
                          <Box
                            w="100%"
                            h="200px"
                            key={index}
                            boxSize="100px"
                            overflow={"hidden"}
                            borderRadius="10px"
                            display={"flex"}
                            justifyContent={"center"}
                            alignItems={"center"}
                            position="relative"
                            mb={2}
                          >
                            <Image
                              src={src}
                              alt={`banner-${index}`}
                              w="auto"
                              h="200px"
                              boxSize="100%"
                              objectFit="contain"
                              borderRadius="10px"
                            />
                            <Button
                              size="xs"
                              position="absolute"
                              top="2px"
                              right="2px"
                              colorScheme="red"
                              borderRadius="full"
                              onClick={() => removeBannerItem(index)}
                            >
                              X
                            </Button>
                          </Box>
                        ))}
                      </Flex>
                      <Flex
                        justify="space-between"
                        align="center"
                        style={{
                          display: "none",
                        }}
                      >
                        <FormLabel
                          color={titleColor}
                          ms="4px"
                          fontSize="sm"
                          fontWeight="normal"
                        >
                          Analytics
                        </FormLabel>
                        <Flex
                          justify="space-between"
                          align="center"
                          w="auto"
                          mb="20px"
                          gap={4}
                        >
                          <Switch
                            colorScheme="teal"
                            size="lg"
                            name="analytics"
                            onChange={handleChange}
                            isChecked={formData.analytics}
                          />
                        </Flex>
                      </Flex>
                      <Flex
                        justify="space-between"
                        align="center"
                        style={{
                          display: "none",
                        }}
                      >
                        <FormLabel
                          color={titleColor}
                          ms="4px"
                          fontSize="sm"
                          fontWeight="normal"
                        >
                          Social Media
                        </FormLabel>
                        <Flex
                          justify="space-between"
                          align="center"
                          w="auto"
                          mb="20px"
                          gap={4}
                        >
                          <Switch
                            colorScheme="teal"
                            size="lg"
                            name="socialMedia"
                            isChecked={formData.socialMedia}
                            variant={"outline"}
                            onChange={handleChange}
                          />
                        </Flex>
                      </Flex>

                      <motion.div
                        initial={{
                          // height: formData.socialMedia ? 0 : 1,
                          // opacity: formData.socialMedia ? 0 : 1,
                          height: isShowAnalytics ? 0 : 1,
                          opacity: isShowAnalytics ? 0 : 1,
                        }}
                        animate={{
                          // height: formData.socialMedia ? "auto" : 0,
                          // opacity: formData.socialMedia ? 1 : 0,
                          height: isShowAnalytics ? "auto" : 0,
                          opacity: isShowAnalytics ? 1 : 0,
                        }}
                        transition={{ duration: 0.3 }}
                        // hidden={!formData.socialMedia}
                        hidden={!isShowAnalytics}
                      >
                        <FormLabel
                          color={titleColor}
                          ms="4px"
                          fontSize="sm"
                          fontWeight="normal"
                        >
                          Select Gender
                        </FormLabel>
                        <GradientBorder
                          mb="24px"
                          h="50px"
                          w="100%"
                          borderRadius="20px"
                        >
                          <Select
                            color={titleColor}
                            bg="rgb(19,21,54)"
                            border="transparent"
                            borderRadius="20px"
                            fontSize="sm"
                            size="lg"
                            w="100%"
                            maxW="100%"
                            h="46px"
                            placeholder="Select Gender"
                            name="gender"
                            value={formData.gender || ""}
                            onChange={handleChange}
                            sx={{
                              option: {
                                backgroundColor: "rgb(19,21,54)",
                                color: "white",
                              },
                            }}
                          >
                            <option value="All">All</option>
                            <option value="Male">Male</option>
                            <option value="Female">Female</option>
                          </Select>
                        </GradientBorder>
                        <FormLabel
                          color={titleColor}
                          ms="4px"
                          fontSize="sm"
                          fontWeight="normal"
                        >
                          Select Age Group
                        </FormLabel>
                        <GradientBorder
                          mb="24px"
                          h="50px"
                          w="100%"
                          borderRadius="20px"
                        >
                          <ChakraStyledSelect
                            placeholder="Select Age Group"
                            options={ageGroupList}
                            selectedValue={selectedAgeGroup}
                            setSelectedValue={setSelectedAgeGroup}
                            isMulti={true}
                          />
                        </GradientBorder>
                        <FormLabel
                          color={titleColor}
                          ms="4px"
                          fontSize="sm"
                          fontWeight="normal"
                        >
                          Location
                        </FormLabel>
                        <GradientBorder
                          mb="24px"
                          minH="50px"
                          w={{ base: "100%", lg: "100%" }}
                          borderRadius="20px"
                        >
                          <ChakraStyledSelect
                            placeholder="Select Locations"
                            options={locationList}
                            selectedValue={selectedLocation}
                            setSelectedValue={setSelectedLocation}
                            isMulti={true}
                          />
                        </GradientBorder>
                        <FormLabel
                          color={titleColor}
                          ms="4px"
                          fontSize="sm"
                          fontWeight="normal"
                        >
                          Interests
                        </FormLabel>
                        <GradientBorder
                          mb="24px"
                          minH="50px"
                          w={{ base: "100%", lg: "100%" }}
                          borderRadius="20px"
                        >
                          <ChakraStyledSelect
                            placeholder="Select Interests"
                            options={interestsList}
                            selectedValue={selectedInterests}
                            setSelectedValue={setSelectedInterests}
                            isMulti={true}
                          />
                        </GradientBorder>

                        {/* <FormLabel
                          color={titleColor}
                          ms="4px"
                          fontSize="sm"
                          fontWeight="normal"
                        >
                          Targetings
                        </FormLabel>
                        <GradientBorder
                          mb="24px"
                          minH="50px"
                          w={{ base: "100%", lg: "100%" }}
                          borderRadius="20px"
                        >
                          <ChakraStyledSelect
                            placeholder="Select Targetings"
                            options={targetingList}
                            selectedValue={selectedTargeting}
                            setSelectedValue={setSelectedTargeting}
                            isMulti={true}
                          />
                        </GradientBorder> */}
                      </motion.div>

                      <FormLabel
                        color={titleColor}
                        ms="4px"
                        fontSize="sm"
                        fontWeight="normal"
                      >
                        Additional Info
                      </FormLabel>

                      <GradientBorder
                        mb="14px"
                        w={{ base: "100%", lg: "100%" }}
                        borderRadius="20px"
                      >
                        <Textarea
                          color={titleColor}
                          bg={{
                            base: "rgb(19,21,54)",
                          }}
                          rows={3}
                          overflowY={"auto"}
                          maxH="4.5em"
                          resize={"none"}
                          border="transparent"
                          borderRadius="20px"
                          fontSize="sm"
                          size="lg"
                          w={{ base: "100%", lg: "100%" }}
                          maxW="100%"
                          type=""
                          placeholder="Additional Info"
                          name="additionalInfo"
                          value={formData.additionalInfo}
                          onChange={handleChange}
                        />
                      </GradientBorder>

                      <Button
                        variant="brand"
                        fontSize="18px"
                        type="submit"
                        w={{ base: "100%", lg: "100%" }}
                        maxW="100%"
                        h="45px"
                        mb="20px"
                        mt="20px"
                      >
                        Submit
                      </Button>
                    </FormControl>
                  </form>
                </Flex>
              </GradientBorder>
            </Flex>
          </CardBody>
        </Card>

        {/* Preview */}
        <Card
          p="22px"
          my={{ sm: "24px", lg: "0px" }}
          ms={{ sm: "0px", lg: "24px" }}
        >
          <Flex direction="column">
            <CardHeader py="12px">
              <Text color="#fff" fontSize="lg" fontWeight="bold">
                Preview
              </Text>
            </CardHeader>
            <CardBody>
              <Flex direction="column" w="100%">
                {/* {billingData.map((row) => {
                  return (
                    <BillingRow
                      Order={row.Order}
                      campaign={row.campaign}
                      publisher={row.publisher}
                    />
                  );
                })} */}
                {/* {selectedbanner && (
                  <Flex direction="column" w="100%" mb="20px">
                    <Text
                      color="#fff"
                      fontSize="lg"
                      fontWeight="500"
                      style={{
                        textTransform: "capitalize",
                        marginBottom: "10px",
                      }}
                    >
                      Banner:
                    </Text>

                    <Box
                      w="100%"
                      h="200px"
                      overflow={"hidden"}
                      borderRadius="10px"
                      display={"flex"}
                      justifyContent={"center"}
                      alignItems={"center"}
                    >
                      <Image
                        src={selectedbanner}
                        alt="Banner"
                        w="auto"
                        h="200px"
                        objectFit="contain"
                        borderRadius="10px"
                      />
                    </Box>
                  </Flex>
                )} */}
                {Object.entries(formData).map(([key, value]) =>
                  value ? (
                    <Text
                      key={key}
                      color="#fff"
                      fontSize="lg"
                      fontWeight="500"
                      style={{
                        textTransform: "capitalize",
                        marginBottom: "10px",
                      }}
                    >
                      {key.replace(/([A-Z])/g, " $1")}:{" "}
                      {typeof value === "boolean" ? (
                        value ? (
                          "Yes"
                        ) : (
                          "No"
                        )
                      ) : key === "advertiser" ? (
                        data.find((item) => item.uuid === value).user.username
                      ) : key === "package" ? (
                        getOrderByType.find((item) => item.uuid === value)
                          ?.package_name ?? ""
                      ) : key === "prgroup" ? (
                        groups.find((item) => item.uuid === value).group_name
                      ) : key === "content" ? (
                        formData?.content?.split("\\").pop()
                      ) : key === "banner" ? (
                        <Flex wrap="wrap" gap={4} mt={2}>
                          {selectedbanner.map((src, index) => (
                            <Box
                              w="100%"
                              h="200px"
                              key={index}
                              boxSize="100px"
                              overflow={"hidden"}
                              borderRadius="10px"
                              display={"flex"}
                              justifyContent={"center"}
                              alignItems={"center"}
                              position="relative"
                            >
                              <Image
                                src={src}
                                alt={`banner-${index}`}
                                w="auto"
                                h="200px"
                                boxSize="100%"
                                objectFit="contain"
                                borderRadius="10px"
                              />
                              <Button
                                size="xs"
                                position="absolute"
                                top="2px"
                                right="2px"
                                colorScheme="red"
                                borderRadius="full"
                                onClick={() => removeBannerItem(index)}
                              >
                                X
                              </Button>
                            </Box>
                          ))}
                        </Flex>
                      ) : (
                        value
                      )}
                    </Text>
                  ) : null
                )}
              </Flex>
            </CardBody>
          </Flex>
        </Card>
      </Grid>
      <GroupModal setGroups={setGroups} isOpen={isOpen} setOpen={setIsOpen} />
    </Flex>
  );
}

export default UpdateCampaign;
